
import FindMovies from "./comp/FindMovies.js";
import Navbar from "./comp/Navbar.js";
import WatchedMovies from "./comp/WatchedMovies.js";
import Box from "./comp/Box.js";
import MovieDetails from "./comp/MovieDetails.js";
import {useState } from "react";
import Error from "./comp/Error.js";
import Loader from "./comp/Loader.js";
import { useMovie } from "./customHooks/useMovie.js";
import { useLocalStrogeState } from "./customHooks/useLocalStrogeState.js";

// const tempWatchedData = [
//   {
//     imdbID: "tt1375666",
//     Title: "Inception",
//     Year: "2010",
//     Poster:
//       "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg",
//     runtime: 148,
//     imdbRating: 8.8,
//     userRating: 10,
//   },
//   {
//     imdbID: "tt0088763",
//     Title: "Back to the Future",
//     Year: "1985",
//     Poster:
//       "https://m.media-amazon.com/images/M/MV5BZmU0M2Y1OGUtZjIxNi00ZjBkLTg1MjgtOWIyNThiZWIwYjRiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_SX300.jpg",
//     runtime: 125,
//     imdbRating: 8.5,
//     userRating: 9,
//   },
// ];
// const tempMovieData = [
//   {
//     imdbID: "tt1375666",
//     Title: "Inception",
//     Year: "2010",
//     Poster:
//       "https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg",
//   },
//   {
//     imdbID: "tt0133093",
//     Title: "The Matrix",
//     Year: "1999",
//     Poster:
//       "https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg",
//   },
//   {
//     imdbID: "tt6751668",
//     Title: "Parasite",
//     Year: "2019",
//     Poster:
//       "https://m.media-amazon.com/images/M/MV5BYWZjMjk3ZTItODQ2ZC00NTY5LWE0ZDYtZTI3MjcwN2Q5NTVkXkEyXkFqcGdeQXVyODk4OTc3MTY@._V1_SX300.jpg",
//   },
// ];
//  const KEY = "3edd0f8a";
function App() {
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [watchedMovie, setWatchedMovie]  =useLocalStrogeState([],"watched")


  const {findMovies, error , loading}=useMovie(query)
  

  function handleSelectedMovie(id){
    setSelectedId(prev=>id===prev ? null :id)
  }

  function handleCloseMovie(){
    setSelectedId(null)
  }

  function handleAddWatchedMovie(movie){
      setWatchedMovie(prev=>[...prev,movie])
      handleCloseMovie();

    
  }

  function handleDeleteWatchedMovie(id){
    setWatchedMovie(prev=>prev.filter(movie=>movie.imdbID !== id))
  }





  return (
    <div className="bg-background900 p-3">
      <Navbar findMovies={findMovies} query={query} setQuery={setQuery} />
    
      <div className="w-[98%] ml-3 mt-3 flex space-x-2"> 
        <Box>
          
          {loading && <Loader />}
          {!loading && !error && (
            <FindMovies findMovies={findMovies} setWatchedMovie={setWatchedMovie} setSelectedId={handleSelectedMovie} />
          )}
          {error && <Error message={error} />}
        </Box>

        <Box>
          {selectedId ? <MovieDetails watchedMovie={watchedMovie} selectedId={selectedId} onClose={handleCloseMovie} onAddWatchedMovie={handleAddWatchedMovie} setSelectedId={setSelectedId} /> : 

          <WatchedMovies watchedMovie={watchedMovie} onDeleteWatchedMovie={handleDeleteWatchedMovie} />
          }
        </Box>
      </div>
    </div>
  );
}





export default App;
